module.exports = __webpack_public_path__ + "src/img/peEdit.acde77ab.svg";